import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { DrRequestInfo } from '../../../models/dr-request-info';
import { Endpoint, HelpIndex } from '../../../models/enums';
import { AlignDirection, CellTemplateType, FilterTemplateType, GenericColDef, GridContext } from '../../../models/grid-context';
import { LoggedUser } from '../../../models/logged-user';
import { CommonService } from '../../../services/common/common.service';
import { RestService } from '../../../services/rest/rest.service';
import { Subscription } from 'rxjs';
import { GenericGridComponent } from '../../generic-grid/generic-grid.component';

@Component({
    standalone: false,
    selector: 'res-system-audit-log',
    templateUrl: './system-audit-log.component.html',
    styleUrls: ['./system-audit-log.component.scss']
})
export class SystemAuditLogComponent implements OnDestroy {
    @ViewChild(GenericGridComponent, { static: true }) systemAuditLogGrid: GenericGridComponent;
    @ViewChild('downloadLink', { read: ElementRef, static: true }) downloadLink: ElementRef;
    modalHelpIndex: HelpIndex;
    automationId = 'system-audit-log';
    gridName = 'System Audit Log';
    requestInfo = new DrRequestInfo({ endpoint: Endpoint.realmManager_listSystemAuditLogs, responseName: 'systemAuditLogs', data: { contextHandle: this.commonService.currentUser?.originalCustomerName === 'super_system_customer' || this.commonService.currentUser?.importedFromSystemUser ? 'super_system_customer' : '', systemScope: true } });
    isGridBusy = false;
    isGridBusyMessage = 'Loading System Audit Log ...';
    downloadTooltip = 'Download (.xlsx)';
    columnDefs = new Array<GenericColDef>(
        {
            headerName: 'Username',
            automationId: this.automationId,
            lockVisible: true,
            field: 'userName',
            minWidth: 30,
            sortBy: 'userName',
            cellTemplateType: CellTemplateType.basicLabelWithTooltip,
            filterType: FilterTemplateType.freeform,
            serviceTierFilter: true,
            filterAttributeName: "USERNAME",
        },
        {
            headerName: 'Date',
            automationId: this.automationId,
            minWidth: 30,
            width: 105,
            headerAlignDirection: AlignDirection.right,
            cellAlignDirection: AlignDirection.right,
            sortBy: 'accessTime',
            defaultSortAscending: false,
            field: 'accessTime',
            cellTemplateType: CellTemplateType.date,
            filterType: FilterTemplateType.date,
            serviceTierFilter: true,
            filterAttributeName: 'ACCESS_TIME',
        },
        {
            headerName: 'Status',
            automationId: this.automationId,
            field: 'status',
            minWidth: 30,
            cellTemplateType: CellTemplateType.basicLabelWithTooltip,
            filterType: FilterTemplateType.freeform,
            serviceTierFilter: true,
            filterAttributeName: "STATUS"
        },
        {
            headerName: 'Operation',
            automationId: this.automationId,
            minWidth: 30,
            field: 'operation',
            cellTemplateType: CellTemplateType.basicLabelWithTooltip,
            filterType: FilterTemplateType.comboBox,
            serviceTierFilter: true,
            filterAttributeName: "OPERATION"
        },
        {
            headerName: 'Description',
            automationId: this.automationId,
            field: 'description',
            minWidth: 30,
            cellTemplateType: CellTemplateType.basicLabelWithTooltip,
            valueGetter: function tokenNameGetter(params) {
                return params.data.description
                    .replace(/>/g, "&gt;")
                    .replace(/</g, "&lt;");
            },
            filterType: FilterTemplateType.freeform,
            serviceTierFilter: true,
            filterAttributeName: "DESCRIPTION"
        },
        {
            headerName: 'Object Name',
            automationId: this.automationId,
            field: 'objectName',
            minWidth: 30,
            cellTemplateType: CellTemplateType.basicLabelWithTooltip,
            filterType: FilterTemplateType.freeform,
            serviceTierFilter: true,
            filterAttributeName: "OBJECT_NAME"
        });

    gridContext = new GridContext({
        sortBy: 'accessTime',
        sortAscendingFieldName: 'descending',
        sortAscending: false,
    });

    constructor(private commonService: CommonService, private restService: RestService) {
    }


    responseCallback = (response: any) => {
        if (response?.systemAuditLogs?.length > 0) {

            const operationNameColDef = this.columnDefs.find(f => f.field === 'operation');
            if (operationNameColDef) {
                const existingItems = operationNameColDef.filterItems || [];
                const newItems = response.systemAuditLogs.map(o => o.operation).filter(op => !existingItems.includes(op));
                operationNameColDef.filterItems = [...existingItems, ...newItems].filter((v, i, a) => a.indexOf(v) === i).sort();
            }

            response.systemAuditLogs = (response.systemAuditLogs as Array<any>).map(u => new LoggedUser(u));
            this.systemAuditLogGrid.refreshColumns();
        }
    }

    openHelp = (): void => this.commonService.openHelp(HelpIndex.sys_audit_log_dlg);


    downloadSystemAuditLog(): void {
        const endpoint = Endpoint.realmManager_getDownloadSystemAuditLogUrl;
         const postParams = {
            filters: this.requestInfo?.data?.filters
        };
        this.restService.post(endpoint, postParams).then(response => {
            if (response) {
                this.commonService.unzipFile(response.url, this.downloadLink.nativeElement, 'SystemAuditLog');
            }
        });
    }

    ngOnDestroy(): void {
    }
}
